import AData from "../tools/AData";
import ABuilder from "../tools/ABuilder";
import Place from "./Place";
import URL from "../tools/URL";

export default class Map {

	constructor() {

		if ($('#map').length > 0) {
			/*
             * Services Points
             */
			this.attachPlaceDetails();

			/*
             * Detect if a place is in the url
             */
			let hashtag = window.location.hash.substr(1);
			let placeUrlID = hashtag.substring(hashtag.indexOf('_') + 1);

			/*
             * Place map
             */
			this.tags = '';
			this.firstLoad = true;
			this.map = false;
			this.polylineMap = false;
			this.markers = [];
			this.markerCluster = false;
			this.myPosition = {};
			this.selectedPlace = false;
			this.urlPlace = placeUrlID;
			this.useMyPosition = false;
			this.placeList = {};
			this.samePlaceList = {};
			this.zoom = 15;
			this.currentZoom = 0;
			this.attachPlaceListAndMap();
			this.attachPlaceFilters();
			this.outlineDrawing = false;
			this.outline = [
				{lng: 6.1275539, lat: 49.893389900000003},
				{lng: 6.1276799, lat: 49.893432900000001},
				{lng: 6.1278169, lat: 49.893485900000002},
				{lng: 6.1278589, lat: 49.893509899999998},
				{lng: 6.1279696, lat: 49.893596899999999},
				{lng: 6.1280459, lat: 49.893641899999999},
				{lng: 6.1281375, lat: 49.893683899999999},
				{lng: 6.1281795, lat: 49.893709899999998},
				{lng: 6.1282214, lat: 49.893771899999997},
				{lng: 6.1282634, lat: 49.893817900000002},
				{lng: 6.1283244, lat: 49.893869899999999},
				{lng: 6.1284846, lat: 49.8938299},
				{lng: 6.1286563, lat: 49.893794900000003},
				{lng: 6.1287899, lat: 49.893769900000002},
				{lng: 6.1291369, lat: 49.893706899999998},
				{lng: 6.1294002, lat: 49.893996899999998},
				{lng: 6.1297319, lat: 49.894381899999999},
				{lng: 6.1305446, lat: 49.894393899999997},
				{lng: 6.1308919, lat: 49.894183900000002},
				{lng: 6.1310979, lat: 49.894899899999999},
				{lng: 6.1311969, lat: 49.895232900000003},
				{lng: 6.1312539, lat: 49.8953439},
				{lng: 6.1314105, lat: 49.895621900000002},
				{lng: 6.1316394, lat: 49.895969899999997},
				{lng: 6.1319865, lat: 49.896205899999998},
				{lng: 6.1320476, lat: 49.896249900000001},
				{lng: 6.1321199, lat: 49.896296900000003},
				{lng: 6.1321773, lat: 49.896335899999997},
				{lng: 6.1324059, lat: 49.896522900000001},
				{lng: 6.1326045, lat: 49.896674900000001},
				{lng: 6.1327304, lat: 49.896773899999999},
				{lng: 6.1328105, lat: 49.896827899999998},
				{lng: 6.1339053, lat: 49.897369900000001},
				{lng: 6.1341989, lat: 49.897532900000002},
				{lng: 6.1345269, lat: 49.897723900000003},
				{lng: 6.1345689, lat: 49.897754900000002},
				{lng: 6.1346072, lat: 49.897792899999999},
				{lng: 6.1346492, lat: 49.8978769},
				{lng: 6.1347293, lat: 49.898009899999998},
				{lng: 6.1348514, lat: 49.898162900000003},
				{lng: 6.1350039, lat: 49.898326900000001},
				{lng: 6.1349809, lat: 49.898437899999998},
				{lng: 6.1354769, lat: 49.898669900000002},
				{lng: 6.1355379, lat: 49.898635900000002},
				{lng: 6.1355799, lat: 49.898609899999997},
				{lng: 6.1356409, lat: 49.898551900000001},
				{lng: 6.1356753, lat: 49.898524899999998},
				{lng: 6.1356869, lat: 49.898513899999998},
				{lng: 6.1356944, lat: 49.898459899999999},
				{lng: 6.1357099, lat: 49.898444900000001},
				{lng: 6.1357289, lat: 49.898433900000001},
				{lng: 6.1357821, lat: 49.898421900000002},
				{lng: 6.1358279, lat: 49.898395899999997},
				{lng: 6.1359079, lat: 49.898299899999998},
				{lng: 6.1359499, lat: 49.898272900000002},
				{lng: 6.1362094, lat: 49.8981499},
				{lng: 6.1362399, lat: 49.898129900000001},
				{lng: 6.1362742, lat: 49.898109900000001},
				{lng: 6.1363009, lat: 49.898097900000003},
				{lng: 6.1363162, lat: 49.898082899999999},
				{lng: 6.1363469, lat: 49.8980599},
				{lng: 6.1363889, lat: 49.898036900000001},
				{lng: 6.1364839, lat: 49.897999900000002},
				{lng: 6.1365756, lat: 49.897933899999998},
				{lng: 6.1366059, lat: 49.897925899999997},
				{lng: 6.1366559, lat: 49.897914900000004},
				{lng: 6.1366899, lat: 49.897899899999999},
				{lng: 6.1367929, lat: 49.897834899999999},
				{lng: 6.1368199, lat: 49.897826899999998},
				{lng: 6.1368693, lat: 49.897819900000002},
				{lng: 6.1368922, lat: 49.897815899999998},
				{lng: 6.1369379, lat: 49.897796900000003},
				{lng: 6.1369876, lat: 49.897761899999999},
				{lng: 6.1370295, lat: 49.897729900000002},
				{lng: 6.1370563, lat: 49.897719899999998},
				{lng: 6.1371402, lat: 49.897709900000002},
				{lng: 6.1371899, lat: 49.897699899999999},
				{lng: 6.1372355, lat: 49.8976799},
				{lng: 6.1372699, lat: 49.897635899999997},
				{lng: 6.1372889, lat: 49.897619900000002},
				{lng: 6.1373195, lat: 49.897605900000002},
				{lng: 6.1373539, lat: 49.897599900000003},
				{lng: 6.1374682, lat: 49.8975899},
				{lng: 6.1375179, lat: 49.897569900000001},
				{lng: 6.1376285, lat: 49.897519899999999},
				{lng: 6.1376742, lat: 49.8974999},
				{lng: 6.1378269, lat: 49.897459900000001},
				{lng: 6.1379529, lat: 49.8974099},
				{lng: 6.1380099, lat: 49.897395899999999},
				{lng: 6.1381015, lat: 49.897384899999999},
				{lng: 6.1381359, lat: 49.897384899999999},
				{lng: 6.1381816, lat: 49.897372900000001},
				{lng: 6.1383037, lat: 49.897323900000004},
				{lng: 6.1384067, lat: 49.897284900000002},
				{lng: 6.1384486, lat: 49.897265900000001},
				{lng: 6.1385209, lat: 49.8972549},
				{lng: 6.1386239, lat: 49.897246899999999},
				{lng: 6.1387349, lat: 49.897229899999999},
				{lng: 6.1387919, lat: 49.8972129},
				{lng: 6.1388186, lat: 49.897199899999997},
				{lng: 6.1388569, lat: 49.897204899999998},
				{lng: 6.1389064, lat: 49.897193899999998},
				{lng: 6.1389636, lat: 49.897174900000003},
				{lng: 6.1390323, lat: 49.897155900000001},
				{lng: 6.1390779, lat: 49.8971369},
				{lng: 6.1391353, lat: 49.897129900000003},
				{lng: 6.1391772, lat: 49.8971199},
				{lng: 6.1392192, lat: 49.897101900000003},
				{lng: 6.1392611, lat: 49.897094899999999},
				{lng: 6.1393029, lat: 49.897082900000001},
				{lng: 6.1393146, lat: 49.897063899999999},
				{lng: 6.1393336, lat: 49.897021899999999},
				{lng: 6.1393489, lat: 49.8969959},
				{lng: 6.1393869, lat: 49.896969900000002},
				{lng: 6.1394519, lat: 49.8969399},
				{lng: 6.1395739, lat: 49.896892899999997},
				{lng: 6.1397494, lat: 49.896811900000003},
				{lng: 6.1398524, lat: 49.896759899999999},
				{lng: 6.1399096, lat: 49.896731899999999},
				{lng: 6.1400355, lat: 49.896682900000002},
				{lng: 6.1400929, lat: 49.896655899999999},
				{lng: 6.1401959, lat: 49.896602899999998},
				{lng: 6.1402415, lat: 49.896569900000003},
				{lng: 6.1402759, lat: 49.896529899999997},
				{lng: 6.1403026, lat: 49.896489899999999},
				{lng: 6.1403139, lat: 49.896476900000003},
				{lng: 6.1403636, lat: 49.8964499},
				{lng: 6.1404399, lat: 49.896426900000002},
				{lng: 6.1405696, lat: 49.896379899999999},
				{lng: 6.1406383, lat: 49.8963429},
				{lng: 6.1407184, lat: 49.896293900000003},
				{lng: 6.1408366, lat: 49.896209900000002},
				{lng: 6.1409169, lat: 49.896163899999998},
				{lng: 6.1410274, lat: 49.8960899},
				{lng: 6.1410922, lat: 49.896052900000001},
				{lng: 6.1411609, lat: 49.896029900000002},
				{lng: 6.1412639, lat: 49.896007900000001},
				{lng: 6.1413592, lat: 49.895989899999996},
				{lng: 6.1414739, lat: 49.8959799},
				{lng: 6.1415805, lat: 49.895976900000001},
				{lng: 6.1416606, lat: 49.8959659},
				{lng: 6.1417179, lat: 49.895953900000002},
				{lng: 6.1417749, lat: 49.895946899999998},
				{lng: 6.1418629, lat: 49.895939900000002},
				{lng: 6.1419505, lat: 49.895929899999999},
				{lng: 6.1420079, lat: 49.895929899999999},
				{lng: 6.1420573, lat: 49.895939900000002},
				{lng: 6.1421069, lat: 49.895942900000001},
				{lng: 6.1421639, lat: 49.895942900000001},
				{lng: 6.1422595, lat: 49.895926899999999},
				{lng: 6.1423359, lat: 49.895911900000002},
				{lng: 6.1424159, lat: 49.895899900000003},
				{lng: 6.1425189, lat: 49.8958929},
				{lng: 6.1426143, lat: 49.8958899},
				{lng: 6.1427209, lat: 49.895879899999997},
				{lng: 6.1427859, lat: 49.895869900000001},
				{lng: 6.1428509, lat: 49.895849900000002},
				{lng: 6.1429042, lat: 49.895831899999997},
				{lng: 6.1429576, lat: 49.895819899999999},
				{lng: 6.1429879, lat: 49.8958169},
				{lng: 6.1430569, lat: 49.895819899999999},
				{lng: 6.1431139, lat: 49.895831899999997},
				{lng: 6.1432019, lat: 49.895854900000003},
				{lng: 6.1433389, lat: 49.895915899999999},
				{lng: 6.1434459, lat: 49.895953900000002},
				{lng: 6.1435299, lat: 49.8959799},
				{lng: 6.1436213, lat: 49.896003899999997},
				{lng: 6.1437282, lat: 49.896022899999998},
				{lng: 6.1438045, lat: 49.896045899999997},
				{lng: 6.1438693, lat: 49.896071900000003},
				{lng: 6.1439609, lat: 49.896094900000001},
				{lng: 6.1440409, lat: 49.896113900000003},
				{lng: 6.1440829, lat: 49.896129899999998},
				{lng: 6.1441516, lat: 49.896149899999998},
				{lng: 6.1442509, lat: 49.896169899999997},
				{lng: 6.1445674, lat: 49.896201900000001},
				{lng: 6.1445939, lat: 49.896102900000002},
				{lng: 6.1446742, lat: 49.8958899},
				{lng: 6.1447123, lat: 49.895809900000003},
				{lng: 6.1448079, lat: 49.895667899999999},
				{lng: 6.1449794, lat: 49.8954399},
				{lng: 6.1450862, lat: 49.895316899999997},
				{lng: 6.1451282, lat: 49.895274899999997},
				{lng: 6.1453685, lat: 49.895095900000001},
				{lng: 6.1458719, lat: 49.8942999},
				{lng: 6.1459445, lat: 49.894129900000003},
				{lng: 6.1460246, lat: 49.8939199},
				{lng: 6.1461352, lat: 49.893699900000001},
				{lng: 6.1461772, lat: 49.893626900000001},
				{lng: 6.1462229, lat: 49.893554899999998},
				{lng: 6.1463565, lat: 49.893374899999998},
				{lng: 6.1462764, lat: 49.893355900000003},
				{lng: 6.1447505, lat: 49.892974899999999},
				{lng: 6.1448419, lat: 49.892739900000002},
				{lng: 6.1444644, lat: 49.892649900000002},
				{lng: 6.1443232, lat: 49.8926199},
				{lng: 6.1441974, lat: 49.892609899999997},
				{lng: 6.1439799, lat: 49.892589899999997},
				{lng: 6.1433199, lat: 49.892189899999998},
				{lng: 6.1429919, lat: 49.892344899999998},
				{lng: 6.1426715, lat: 49.892469900000002},
				{lng: 6.1425303, lat: 49.892516899999997},
				{lng: 6.1414739, lat: 49.892439899999999},
				{lng: 6.1413096, lat: 49.8924369},
				{lng: 6.1408749, lat: 49.892482899999997},
				{lng: 6.1406306, lat: 49.892505900000003},
				{lng: 6.1404742, lat: 49.892519900000003},
				{lng: 6.1398869, lat: 49.892379900000002},
				{lng: 6.1397914, lat: 49.892339900000003},
				{lng: 6.1395929, lat: 49.892257899999997},
				{lng: 6.1390513, lat: 49.892142900000003},
				{lng: 6.1389255, lat: 49.892119899999997},
				{lng: 6.1386319, lat: 49.892079899999999},
				{lng: 6.1385019, lat: 49.892049900000004},
				{lng: 6.1382731, lat: 49.891993900000003},
				{lng: 6.1381282, lat: 49.891955899999999},
				{lng: 6.1380023, lat: 49.891909900000002},
				{lng: 6.1379832, lat: 49.891894899999997},
				{lng: 6.1379756, lat: 49.891849899999997},
				{lng: 6.1379413, lat: 49.891673900000001},
				{lng: 6.1379184, lat: 49.8915699},
				{lng: 6.1379146, lat: 49.891539899999998},
				{lng: 6.1378955, lat: 49.8915249},
				{lng: 6.1377889, lat: 49.891469899999997},
				{lng: 6.1377809, lat: 49.8914069},
				{lng: 6.1380099, lat: 49.8914379},
				{lng: 6.1387233, lat: 49.891532900000001},
				{lng: 6.1389369, lat: 49.891284900000002},
				{lng: 6.1389409, lat: 49.891253900000002},
				{lng: 6.1389369, lat: 49.891124900000001},
				{lng: 6.1389445, lat: 49.890883899999999},
				{lng: 6.1398066, lat: 49.890839900000003},
				{lng: 6.1402072, lat: 49.8908159},
				{lng: 6.1406079, lat: 49.890779899999998},
				{lng: 6.1405849, lat: 49.890709899999997},
				{lng: 6.1410274, lat: 49.890519900000001},
				{lng: 6.1414012, lat: 49.890372900000003},
				{lng: 6.1416453, lat: 49.890292899999999},
				{lng: 6.1418399, lat: 49.890239899999997},
				{lng: 6.1420382, lat: 49.8901939},
				{lng: 6.1422214, lat: 49.8901599},
				{lng: 6.1423549, lat: 49.890151899999999},
				{lng: 6.1425759, lat: 49.890149899999997},
				{lng: 6.1428012, lat: 49.890149899999997},
				{lng: 6.1428126, lat: 49.8900899},
				{lng: 6.1428164, lat: 49.890021900000001},
				{lng: 6.1428164, lat: 49.889959900000001},
				{lng: 6.1434573, lat: 49.890079900000003},
				{lng: 6.1438006, lat: 49.890149899999997},
				{lng: 6.1443119, lat: 49.890277900000001},
				{lng: 6.1447963, lat: 49.8904079},
				{lng: 6.1448689, lat: 49.890429900000001},
				{lng: 6.1455172, lat: 49.890613899999998},
				{lng: 6.1458339, lat: 49.890709899999997},
				{lng: 6.1462382, lat: 49.890819899999997},
				{lng: 6.1467647, lat: 49.890949900000003},
				{lng: 6.1467759, lat: 49.890906899999997},
				{lng: 6.1468104, lat: 49.8907849},
				{lng: 6.1468333, lat: 49.890681899999997},
				{lng: 6.1468599, lat: 49.890567900000001},
				{lng: 6.1468869, lat: 49.890469899999999},
				{lng: 6.1471766, lat: 49.890339900000001},
				{lng: 6.1473025, lat: 49.890262900000003},
				{lng: 6.1474894, lat: 49.890124900000004},
				{lng: 6.1476879, lat: 49.889956900000001},
				{lng: 6.1478899, lat: 49.889789899999997},
				{lng: 6.1481036, lat: 49.889617899999998},
				{lng: 6.1481759, lat: 49.889569899999998},
				{lng: 6.1482449, lat: 49.889522900000003},
				{lng: 6.1484319, lat: 49.889411899999999},
				{lng: 6.1493052, lat: 49.888957900000001},
				{lng: 6.1495379, lat: 49.888846899999997},
				{lng: 6.1497516, lat: 49.888762900000003},
				{lng: 6.1502475, lat: 49.8885729},
				{lng: 6.1504802, lat: 49.888599900000003},
				{lng: 6.1510562, lat: 49.888244899999997},
				{lng: 6.1516019, lat: 49.887896900000001},
				{lng: 6.1516819, lat: 49.8878299},
				{lng: 6.1518153, lat: 49.887671900000001},
				{lng: 6.1523112, lat: 49.887034900000003},
				{lng: 6.1523646, lat: 49.8869629},
				{lng: 6.1526849, lat: 49.886546899999999},
				{lng: 6.1530169, lat: 49.886079899999999},
				{lng: 6.1530665, lat: 49.885999900000002},
				{lng: 6.1533984, lat: 49.885653900000001},
				{lng: 6.1535434, lat: 49.885512900000002},
				{lng: 6.1537989, lat: 49.8852999},
				{lng: 6.1544246, lat: 49.884692899999997},
				{lng: 6.1547984, lat: 49.884376899999999},
				{lng: 6.1554239, lat: 49.883906899999999},
				{lng: 6.1555995, lat: 49.883792900000003},
				{lng: 6.1556262, lat: 49.883829900000002},
				{lng: 6.1556834, lat: 49.883876899999997},
				{lng: 6.1557979, lat: 49.883906899999999},
				{lng: 6.1559123, lat: 49.883925900000001},
				{lng: 6.1560269, lat: 49.883937899999999},
				{lng: 6.1560609, lat: 49.883914900000001},
				{lng: 6.1566562, lat: 49.883674900000003},
				{lng: 6.1573504, lat: 49.883403899999998},
				{lng: 6.1586549, lat: 49.882914900000003},
				{lng: 6.1582545, lat: 49.882411900000001},
				{lng: 6.1590022, lat: 49.882199900000003},
				{lng: 6.1593303, lat: 49.8820999},
				{lng: 6.1594333, lat: 49.882083899999998},
				{lng: 6.1596469, lat: 49.882075899999997},
				{lng: 6.1600209, lat: 49.882059900000002},
				{lng: 6.1601659, lat: 49.882049899999998},
				{lng: 6.1603145, lat: 49.882029899999999},
				{lng: 6.1605243, lat: 49.881999899999997},
				{lng: 6.1606159, lat: 49.881979899999997},
				{lng: 6.1607036, lat: 49.881949900000002},
				{lng: 6.1614512, lat: 49.881667899999997},
				{lng: 6.1626299, lat: 49.881879900000001},
				{lng: 6.1634389, lat: 49.8820269},
				{lng: 6.1634999, lat: 49.882033900000003},
				{lng: 6.1635339, lat: 49.882033900000003},
				{lng: 6.1636714, lat: 49.882022900000003},
				{lng: 6.1640149, lat: 49.881984899999999},
				{lng: 6.1641369, lat: 49.881969900000001},
				{lng: 6.1643504, lat: 49.881949900000002},
				{lng: 6.1645106, lat: 49.882377900000002},
				{lng: 6.1648654, lat: 49.882281900000002},
				{lng: 6.1651479, lat: 49.882199900000003},
				{lng: 6.1655215, lat: 49.8820719},
				{lng: 6.1656399, lat: 49.882022900000003},
				{lng: 6.1660365, lat: 49.881751899999998},
				{lng: 6.1656819, lat: 49.881461899999998},
				{lng: 6.1662309, lat: 49.8811149},
				{lng: 6.1665744, lat: 49.880904899999997},
				{lng: 6.1667879, lat: 49.880759900000001},
				{lng: 6.1668261, lat: 49.880732899999998},
				{lng: 6.1668643, lat: 49.880702900000003},
				{lng: 6.1669215, lat: 49.880669900000001},
				{lng: 6.1671199, lat: 49.8805269},
				{lng: 6.1674365, lat: 49.880332899999999},
				{lng: 6.1680889, lat: 49.8799499},
				{lng: 6.1685429, lat: 49.879706900000002},
				{lng: 6.1689279, lat: 49.879512900000002},
				{lng: 6.1691684, lat: 49.879401899999998},
				{lng: 6.1696414, lat: 49.879219900000002},
				{lng: 6.1701602, lat: 49.8790099},
				{lng: 6.1702099, lat: 49.878993899999998},
				{lng: 6.1704196, lat: 49.878917899999998},
				{lng: 6.1709002, lat: 49.878783900000002},
				{lng: 6.1710376, lat: 49.878741900000001},
				{lng: 6.1711825, lat: 49.878684900000003},
				{lng: 6.1714189, lat: 49.878562899999999},
				{lng: 6.1715909, lat: 49.878474900000001},
				{lng: 6.1719111, lat: 49.878303899999999},
				{lng: 6.1722506, lat: 49.878093900000003},
				{lng: 6.1726092, lat: 49.877875899999999},
				{lng: 6.1728534, lat: 49.877723899999999},
				{lng: 6.1731051, lat: 49.877933900000002},
				{lng: 6.1733073, lat: 49.877829900000002},
				{lng: 6.1734523, lat: 49.877759900000001},
				{lng: 6.1736354, lat: 49.877699900000003},
				{lng: 6.1738452, lat: 49.877631899999997},
				{lng: 6.1739024, lat: 49.877609900000003},
				{lng: 6.1739939, lat: 49.877559900000001},
				{lng: 6.1740969, lat: 49.8775099},
				{lng: 6.1742459, lat: 49.877479899999997},
				{lng: 6.1744059, lat: 49.877439899999999},
				{lng: 6.1745699, lat: 49.877383899999998},
				{lng: 6.1746579, lat: 49.877345900000002},
				{lng: 6.1747379, lat: 49.8772959},
				{lng: 6.1747759, lat: 49.877269900000002},
				{lng: 6.1748979, lat: 49.877189899999998},
				{lng: 6.1751689, lat: 49.876989899999998},
				{lng: 6.1753596, lat: 49.876971900000001},
				{lng: 6.1755504, lat: 49.876952899999999},
				{lng: 6.1755849, lat: 49.876952899999999},
				{lng: 6.1756076, lat: 49.876964899999997},
				{lng: 6.1759469, lat: 49.876937900000001},
				{lng: 6.1761722, lat: 49.876922899999997},
				{lng: 6.1763819, lat: 49.876909900000001},
				{lng: 6.1764009, lat: 49.876906900000002},
				{lng: 6.1764279, lat: 49.876906900000002},
				{lng: 6.1765384, lat: 49.876895900000001},
				{lng: 6.1765002, lat: 49.876819900000001},
				{lng: 6.1764506, lat: 49.876629899999998},
				{lng: 6.1764316, lat: 49.876529900000001},
				{lng: 6.1764089, lat: 49.876349900000001},
				{lng: 6.1763972, lat: 49.876162899999997},
				{lng: 6.1763972, lat: 49.876119899999999},
				{lng: 6.1764049, lat: 49.875876900000002},
				{lng: 6.176409, lat: 49.875639900000003},
				{lng: 6.1764126, lat: 49.875589900000001},
				{lng: 6.17642, lat: 49.875392900000001},
				{lng: 6.176447, lat: 49.8751259},
				{lng: 6.176626, lat: 49.875121900000003},
				{lng: 6.176813, lat: 49.875121900000003},
				{lng: 6.1769886, lat: 49.8751259},
				{lng: 6.177698, lat: 49.875129899999997},
				{lng: 6.177664, lat: 49.874739900000002},
				{lng: 6.177637, lat: 49.874415900000002},
				{lng: 6.177622, lat: 49.874069900000002},
				{lng: 6.1776066, lat: 49.873774900000001},
				{lng: 6.178316, lat: 49.873843899999997},
				{lng: 6.1785183, lat: 49.873862899999999},
				{lng: 6.178686, lat: 49.873879899999999},
				{lng: 6.1789494, lat: 49.873899899999998},
				{lng: 6.1792545, lat: 49.873927899999998},
				{lng: 6.179899, lat: 49.873984900000004},
				{lng: 6.1800175, lat: 49.873699899999998},
				{lng: 6.1800747, lat: 49.8735699},
				{lng: 6.1801014, lat: 49.8735049},
				{lng: 6.180231, lat: 49.873269899999997},
				{lng: 6.1803189, lat: 49.873119899999999},
				{lng: 6.1803379, lat: 49.873084900000002},
				{lng: 6.1804027, lat: 49.872973899999998},
				{lng: 6.1805362, lat: 49.872737899999997},
				{lng: 6.1805476, lat: 49.8727199},
				{lng: 6.1805972, lat: 49.872634900000001},
				{lng: 6.1806199, lat: 49.872603900000001},
				{lng: 6.1806315, lat: 49.872577900000003},
				{lng: 6.1806582, lat: 49.872523899999997},
				{lng: 6.1804866, lat: 49.872481899999997},
				{lng: 6.1802769, lat: 49.872436899999997},
				{lng: 6.1800249, lat: 49.872379899999999},
				{lng: 6.1799144, lat: 49.872352900000003},
				{lng: 6.1799182, lat: 49.8723399},
				{lng: 6.1799296, lat: 49.872321900000003},
				{lng: 6.1798189, lat: 49.872302900000001},
				{lng: 6.1797313, lat: 49.8722949},
				{lng: 6.1796319, lat: 49.872302900000001},
				{lng: 6.1791169, lat: 49.872399899999998},
				{lng: 6.1790065, lat: 49.872424899999999},
				{lng: 6.1789035, lat: 49.8724299},
				{lng: 6.1787469, lat: 49.872424899999999},
				{lng: 6.1784572, lat: 49.872394900000003},
				{lng: 6.1783769, lat: 49.872379899999999},
				{lng: 6.1782589, lat: 49.872349900000003},
				{lng: 6.1779839, lat: 49.872269899999999},
				{lng: 6.1779459, lat: 49.872264899999998},
				{lng: 6.1779229, lat: 49.872271900000001},
				{lng: 6.1777743, lat: 49.872363900000003},
				{lng: 6.1777896, lat: 49.872389900000002},
				{lng: 6.1775989, lat: 49.8725199},
				{lng: 6.1772822, lat: 49.872333900000001},
				{lng: 6.1771069, lat: 49.872245900000003},
				{lng: 6.1769999, lat: 49.872203900000002},
				{lng: 6.1768739, lat: 49.872165899999999},
				{lng: 6.1767559, lat: 49.872139900000001},
				{lng: 6.1765193, lat: 49.872096900000003},
				{lng: 6.1763859, lat: 49.872073899999997},
				{lng: 6.1763859, lat: 49.872062900000003},
				{lng: 6.1763972, lat: 49.871985899999999},
				{lng: 6.1764009, lat: 49.871943899999998},
				{lng: 6.1763972, lat: 49.871789900000003},
				{lng: 6.1764199, lat: 49.871719900000002},
				{lng: 6.1764239, lat: 49.871684899999998},
				{lng: 6.1764199, lat: 49.871623900000003},
				{lng: 6.1764239, lat: 49.871592900000003},
				{lng: 6.1764619, lat: 49.871482899999997},
				{lng: 6.1764699, lat: 49.871369899999998},
				{lng: 6.1764889, lat: 49.871289900000001},
				{lng: 6.1765079, lat: 49.871289900000001},
				{lng: 6.1766259, lat: 49.870994899999999},
				{lng: 6.1766759, lat: 49.870864900000001},
				{lng: 6.1768739, lat: 49.870469900000003},
				{lng: 6.1769465, lat: 49.870395899999998},
				{lng: 6.1769809, lat: 49.870345899999997},
				{lng: 6.1770379, lat: 49.8702349},
				{lng: 6.1770572, lat: 49.870185900000003},
				{lng: 6.1771602, lat: 49.8699899},
				{lng: 6.1775379, lat: 49.870019900000003},
				{lng: 6.1775949, lat: 49.870029899999999},
				{lng: 6.1779229, lat: 49.870055899999997},
				{lng: 6.1782054, lat: 49.870093900000001},
				{lng: 6.1784305, lat: 49.870131899999997},
				{lng: 6.1784686, lat: 49.870139899999998},
				{lng: 6.1786746, lat: 49.8701699},
				{lng: 6.1789416, lat: 49.8692359},
				{lng: 6.1789493, lat: 49.869216899999998},
				{lng: 6.1789609, lat: 49.869179899999999},
				{lng: 6.1791819, lat: 49.869209900000001},
				{lng: 6.1795289, lat: 49.868632900000001},
				{lng: 6.1795596, lat: 49.868549899999998},
				{lng: 6.1788005, lat: 49.868415900000002},
				{lng: 6.1785069, lat: 49.868377899999999},
				{lng: 6.1777324, lat: 49.868289900000001},
				{lng: 6.1770799, lat: 49.8682199},
				{lng: 6.1756989, lat: 49.868106900000001},
				{lng: 6.1757219, lat: 49.868007900000002},
				{lng: 6.1757259, lat: 49.867979900000002},
				{lng: 6.1757564, lat: 49.867866900000003},
				{lng: 6.1757754, lat: 49.867789899999998},
				{lng: 6.1759242, lat: 49.867045900000001},
				{lng: 6.1760234, lat: 49.8667029},
				{lng: 6.1760349, lat: 49.866669899999998},
				{lng: 6.1762409, lat: 49.866709899999996},
				{lng: 6.1764699, lat: 49.866183900000003},
				{lng: 6.1761493, lat: 49.866065900000002},
				{lng: 6.1760349, lat: 49.866046900000001},
				{lng: 6.1759242, lat: 49.866034900000002},
				{lng: 6.1759469, lat: 49.865996899999999},
				{lng: 6.1758212, lat: 49.865981900000001},
				{lng: 6.1753289, lat: 49.865919900000002},
				{lng: 6.1753789, lat: 49.865817900000003},
				{lng: 6.1753253, lat: 49.865802899999998},
				{lng: 6.1754207, lat: 49.865695899999999},
				{lng: 6.1754739, lat: 49.865634900000003},
				{lng: 6.1755769, lat: 49.865509899999999},
				{lng: 6.1756609, lat: 49.8654139},
				{lng: 6.1757489, lat: 49.865302900000003},
				{lng: 6.1758784, lat: 49.865142900000002},
				{lng: 6.1761379, lat: 49.864819900000001},
				{lng: 6.1762829, lat: 49.864627900000002},
				{lng: 6.1761836, lat: 49.864581899999997},
				{lng: 6.1760119, lat: 49.864505899999997},
				{lng: 6.1759049, lat: 49.864455900000003},
				{lng: 6.1757869, lat: 49.864402900000002},
				{lng: 6.1756989, lat: 49.864364899999998},
				{lng: 6.1756879, lat: 49.864356899999997},
				{lng: 6.1756609, lat: 49.864345899999996},
				{lng: 6.1755429, lat: 49.864272900000003},
				{lng: 6.1754589, lat: 49.864253900000001},
				{lng: 6.1752833, lat: 49.864211900000001},
				{lng: 6.1749019, lat: 49.864119899999999},
				{lng: 6.1748446, lat: 49.864104900000001},
				{lng: 6.1747302, lat: 49.8640939},
				{lng: 6.1744709, lat: 49.8640629},
				{lng: 6.1741579, lat: 49.864032899999998},
				{lng: 6.1739863, lat: 49.864005900000002},
				{lng: 6.1738719, lat: 49.8639899},
				{lng: 6.1736889, lat: 49.863959899999998},
				{lng: 6.1735629, lat: 49.863939899999998},
				{lng: 6.1734103, lat: 49.863919899999999},
				{lng: 6.1733417, lat: 49.863906900000003},
				{lng: 6.1731699, lat: 49.863879900000001},
				{lng: 6.1730899, lat: 49.863869899999997},
				{lng: 6.1730709, lat: 49.863864900000003},
				{lng: 6.1728915, lat: 49.863839900000002},
				{lng: 6.1727656, lat: 49.863819900000003},
				{lng: 6.1725024, lat: 49.8637899},
				{lng: 6.1724223, lat: 49.863776899999998},
				{lng: 6.1723575, lat: 49.863769900000001},
				{lng: 6.1722889, lat: 49.863757900000003},
				{lng: 6.1722735, lat: 49.863757900000003},
				{lng: 6.1718081, lat: 49.8636859},
				{lng: 6.1716479, lat: 49.863662900000001},
				{lng: 6.1715909, lat: 49.863649899999999},
				{lng: 6.1715219, lat: 49.8636439},
				{lng: 6.1706943, lat: 49.863513900000001},
				{lng: 6.1705189, lat: 49.863489899999998},
				{lng: 6.1703814, lat: 49.8634719},
				{lng: 6.1701869, lat: 49.863452899999999},
				{lng: 6.1696759, lat: 49.863414900000002},
				{lng: 6.1695384, lat: 49.863402899999997},
				{lng: 6.1690692, lat: 49.863359899999999},
				{lng: 6.1689969, lat: 49.8633539},
				{lng: 6.1684779, lat: 49.863307900000002},
				{lng: 6.1684092, lat: 49.863303899999998},
				{lng: 6.1682033, lat: 49.863284899999996},
				{lng: 6.1678979, lat: 49.863259900000003},
				{lng: 6.1679515, lat: 49.8631399},
				{lng: 6.1680125, lat: 49.862983900000003},
				{lng: 6.1680279, lat: 49.8629459},
				{lng: 6.1680812, lat: 49.862739900000001},
				{lng: 6.1681039, lat: 49.862647899999999},
				{lng: 6.1681079, lat: 49.8625799},
				{lng: 6.1681079, lat: 49.862445899999997},
				{lng: 6.1679479, lat: 49.862549899999998},
				{lng: 6.1678256, lat: 49.862609900000002},
				{lng: 6.1677264, lat: 49.862647899999999},
				{lng: 6.1676196, lat: 49.862685900000002},
				{lng: 6.1674939, lat: 49.862704899999997},
				{lng: 6.1673869, lat: 49.862704899999997},
				{lng: 6.1672305, lat: 49.862681899999998},
				{lng: 6.1669749, lat: 49.862647899999999},
				{lng: 6.1666659, lat: 49.862594899999998},
				{lng: 6.1664256, lat: 49.862555899999997},
				{lng: 6.1662959, lat: 49.862544900000003},
				{lng: 6.1660975, lat: 49.862549899999998},
				{lng: 6.1659639, lat: 49.862549899999998},
				{lng: 6.1657886, lat: 49.862529899999998},
				{lng: 6.1654529, lat: 49.862487899999998},
				{lng: 6.1653384, lat: 49.8624729},
				{lng: 6.1650676, lat: 49.8624419},
				{lng: 6.1649226, lat: 49.862409900000003},
				{lng: 6.1646594, lat: 49.862346899999999},
				{lng: 6.1644189, lat: 49.862279899999997},
				{lng: 6.1644534, lat: 49.862151900000001},
				{lng: 6.1644799, lat: 49.862044900000001},
				{lng: 6.1644954, lat: 49.861972899999998},
				{lng: 6.1645299, lat: 49.8618399},
				{lng: 6.1645411, lat: 49.861793900000002},
				{lng: 6.1645526, lat: 49.8617439},
				{lng: 6.1645793, lat: 49.861619900000001},
				{lng: 6.1645984, lat: 49.861537900000002},
				{lng: 6.1646213, lat: 49.8614429},
				{lng: 6.1646669, lat: 49.861269900000003},
				{lng: 6.1647089, lat: 49.861094899999998},
				{lng: 6.1647359, lat: 49.860969900000001},
				{lng: 6.1647624, lat: 49.860839900000002},
				{lng: 6.1648539, lat: 49.8604299},
				{lng: 6.1648616, lat: 49.860389900000001},
				{lng: 6.1649149, lat: 49.860179899999999},
				{lng: 6.1649226, lat: 49.860137899999998},
				{lng: 6.1649569, lat: 49.859977899999997},
				{lng: 6.1650065, lat: 49.859694900000001},
				{lng: 6.1650179, lat: 49.8596419},
				{lng: 6.1647549, lat: 49.8595349},
				{lng: 6.1646365, lat: 49.859485900000003},
				{lng: 6.1641599, lat: 49.859279899999997},
				{lng: 6.1638699, lat: 49.859145900000001},
				{lng: 6.1637095, lat: 49.859076899999998},
				{lng: 6.1635759, lat: 49.859039899999999},
				{lng: 6.1634959, lat: 49.858989899999997},
				{lng: 6.1634119, lat: 49.858954900000001},
				{lng: 6.1633319, lat: 49.858931900000002},
				{lng: 6.1632174, lat: 49.858924899999998},
				{lng: 6.1630799, lat: 49.8589299},
				{lng: 6.1628283, lat: 49.858935899999999},
				{lng: 6.1626679, lat: 49.8589299},
				{lng: 6.1625384, lat: 49.858919899999997},
				{lng: 6.1623553, lat: 49.858886900000002},
				{lng: 6.1622029, lat: 49.858844900000001},
				{lng: 6.1620769, lat: 49.858799900000001},
				{lng: 6.1619586, lat: 49.858733899999997},
				{lng: 6.1617984, lat: 49.858609899999998},
				{lng: 6.1616534, lat: 49.858516899999998},
				{lng: 6.1614894, lat: 49.858432899999997},
				{lng: 6.1613139, lat: 49.858336899999998},
				{lng: 6.1611649, lat: 49.858272900000003},
				{lng: 6.1609744, lat: 49.858207899999996},
				{lng: 6.1608256, lat: 49.858139899999998},
				{lng: 6.1606389, lat: 49.858039900000001},
				{lng: 6.1605889, lat: 49.858039900000001},
				{lng: 6.1602153, lat: 49.857979899999997},
				{lng: 6.1601047, lat: 49.857839900000002},
				{lng: 6.1600512, lat: 49.857783900000001},
				{lng: 6.1600017, lat: 49.857741900000001},
				{lng: 6.1599369, lat: 49.8576999},
				{lng: 6.1599139, lat: 49.857669899999998},
				{lng: 6.1597539, lat: 49.857419899999996},
				{lng: 6.1596699, lat: 49.857306899999998},
				{lng: 6.1595172, lat: 49.857161900000001},
				{lng: 6.1593419, lat: 49.857013899999998},
				{lng: 6.1591279, lat: 49.856845900000003},
				{lng: 6.1587504, lat: 49.856559900000001},
				{lng: 6.1585902, lat: 49.8564449},
				{lng: 6.1583156, lat: 49.856269900000001},
				{lng: 6.1581286, lat: 49.856159900000002},
				{lng: 6.1579532, lat: 49.856079899999997},
				{lng: 6.1575793, lat: 49.855933899999997},
				{lng: 6.1578349, lat: 49.855441900000002},
				{lng: 6.1580639, lat: 49.855037899999999},
				{lng: 6.1582849, lat: 49.854693900000001},
				{lng: 6.1586129, lat: 49.854106899999998},
				{lng: 6.1587429, lat: 49.853839899999997},
				{lng: 6.158945, lat: 49.853259899999998},
				{lng: 6.1589756, lat: 49.853156900000002},
				{lng: 6.158983, lat: 49.8531099},
				{lng: 6.158983, lat: 49.853076899999998},
				{lng: 6.158968, lat: 49.853042899999998},
				{lng: 6.158922, lat: 49.852979900000001},
				{lng: 6.158617, lat: 49.852664900000001},
				{lng: 6.1584263, lat: 49.852429899999997},
				{lng: 6.1582775, lat: 49.852158000000003},
				{lng: 6.1582165, lat: 49.852069999999998},
				{lng: 6.158121, lat: 49.851959999999998},
				{lng: 6.1580257, lat: 49.851860000000002},
				{lng: 6.157873, lat: 49.851695999999997},
				{lng: 6.157774, lat: 49.851593000000001},
				{lng: 6.157606, lat: 49.851444000000001},
				{lng: 6.1572437, lat: 49.851129999999998},
				{lng: 6.157099, lat: 49.850997999999997},
				{lng: 6.1568775, lat: 49.850830000000002},
				{lng: 6.15674, lat: 49.850740000000002},
				{lng: 6.1565304, lat: 49.850636000000002},
				{lng: 6.1563587, lat: 49.850563000000001},
				{lng: 6.156187, lat: 49.850501999999999},
				{lng: 6.1559963, lat: 49.850445000000001},
				{lng: 6.1560116, lat: 49.85033},
				{lng: 6.1559772, lat: 49.850315000000002},
				{lng: 6.156042, lat: 49.849629999999998},
				{lng: 6.1561604, lat: 49.848736000000002},
				{lng: 6.156252, lat: 49.848025999999997},
				{lng: 6.156294, lat: 49.848025999999997},
				{lng: 6.156042, lat: 49.847667999999999},
				{lng: 6.1559772, lat: 49.847572},
				{lng: 6.155878, lat: 49.847416000000003},
				{lng: 6.15584, lat: 49.847329999999999},
				{lng: 6.1558094, lat: 49.847256000000002},
				{lng: 6.1557827, lat: 49.847157000000003},
				{lng: 6.155779, lat: 49.847119999999997},
				{lng: 6.155775, lat: 49.847099999999998},
				{lng: 6.1557713, lat: 49.847029999999997},
				{lng: 6.1557674, lat: 49.84693},
				{lng: 6.1557713, lat: 49.846850000000003},
				{lng: 6.1557713, lat: 49.846831999999999},
				{lng: 6.1557827, lat: 49.846606999999999},
				{lng: 6.155813, lat: 49.846232999999998},
				{lng: 6.1558437, lat: 49.845770000000002},
				{lng: 6.1558857, lat: 49.84543},
				{lng: 6.15592, lat: 49.845309999999998},
				{lng: 6.1559315, lat: 49.845154000000001},
				{lng: 6.155924, lat: 49.845066000000003},
				{lng: 6.1559124, lat: 49.844974999999998},
				{lng: 6.155897, lat: 49.844822000000001},
				{lng: 6.1558933, lat: 49.844799999999999},
				{lng: 6.1558857, lat: 49.844729999999998},
				{lng: 6.1558514, lat: 49.844532000000001},
				{lng: 6.1558056, lat: 49.844363999999999},
				{lng: 6.15571, lat: 49.844110000000001},
				{lng: 6.1556873, lat: 49.844048000000001},
				{lng: 6.1557026, lat: 49.844000000000001},
				{lng: 6.155794, lat: 49.843699999999998},
				{lng: 6.155802, lat: 49.843646999999997},
				{lng: 6.155798, lat: 49.843604999999997},
				{lng: 6.155733, lat: 49.843310000000002},
				{lng: 6.1557293, lat: 49.843254000000002},
				{lng: 6.1557903, lat: 49.843240000000002},
				{lng: 6.1558514, lat: 49.843226999999999},
				{lng: 6.155943, lat: 49.843229999999998},
				{lng: 6.156061, lat: 49.843240000000002},
				{lng: 6.1562405, lat: 49.843254000000002},
				{lng: 6.1563473, lat: 49.843260000000001},
				{lng: 6.1564884, lat: 49.843249999999998},
				{lng: 6.156599, lat: 49.843246000000001},
				{lng: 6.156824, lat: 49.843257999999999},
				{lng: 6.1572094, lat: 49.843273000000003},
				{lng: 6.1574726, lat: 49.843269999999997},
				{lng: 6.157675, lat: 49.843277},
				{lng: 6.1580524, lat: 49.843296000000002},
				{lng: 6.158407, lat: 49.843290000000003},
				{lng: 6.158655, lat: 49.843296000000002},
				{lng: 6.159094, lat: 49.843304000000003},
				{lng: 6.159273, lat: 49.843304000000003},
				{lng: 6.159487, lat: 49.843296000000002},
				{lng: 6.1596622, lat: 49.843304000000003},
				{lng: 6.159773, lat: 49.843307000000003},
				{lng: 6.16012, lat: 49.843299999999999},
				{lng: 6.160284, lat: 49.843285000000002},
				{lng: 6.1605625, lat: 49.843246000000001},
				{lng: 6.160654, lat: 49.843243000000001},
				{lng: 6.160986, lat: 49.843243000000001},
				{lng: 6.1611195, lat: 49.843226999999999},
				{lng: 6.161207, lat: 49.843215999999998},
				{lng: 6.161661, lat: 49.843094000000001},
				{lng: 6.1622906, lat: 49.842934},
				{lng: 6.162512, lat: 49.842865000000003},
				{lng: 6.163027, lat: 49.842677999999999},
				{lng: 6.163286, lat: 49.842582999999998},
				{lng: 6.163435, lat: 49.842529999999996},
				{lng: 6.163492, lat: 49.842506},
				{lng: 6.1634235, lat: 49.842500000000001},
				{lng: 6.1633625, lat: 49.842506},
				{lng: 6.1633053, lat: 49.842503000000001},
				{lng: 6.163271, lat: 49.842500000000001},
				{lng: 6.16321, lat: 49.842480000000002},
				{lng: 6.1631603, lat: 49.842449999999999},
				{lng: 6.1630955, lat: 49.842433999999997},
				{lng: 6.163042, lat: 49.842419999999997},
				{lng: 6.1630077, lat: 49.842399999999998},
				{lng: 6.162966, lat: 49.842396000000001},
				{lng: 6.162924, lat: 49.842390000000002},
				{lng: 6.1628933, lat: 49.842373000000002},
				{lng: 6.1628704, lat: 49.842357999999997},
				{lng: 6.1628475, lat: 49.842350000000003},
				{lng: 6.162798, lat: 49.842342000000002},
				{lng: 6.16271, lat: 49.842315999999997},
				{lng: 6.162676, lat: 49.842297000000002},
				{lng: 6.162653, lat: 49.842289999999998},
				{lng: 6.162554, lat: 49.842278},
				{lng: 6.162485, lat: 49.842274000000003},
				{lng: 6.1624393, lat: 49.842261999999998},
				{lng: 6.1623898, lat: 49.842239999999997},
				{lng: 6.1623554, lat: 49.842236},
				{lng: 6.162298, lat: 49.842224000000002},
				{lng: 6.1622486, lat: 49.842213000000001},
				{lng: 6.162199, lat: 49.842190000000002},
				{lng: 6.16218, lat: 49.842185999999998},
				{lng: 6.1620884, lat: 49.842185999999998},
				{lng: 6.162058, lat: 49.842174999999997},
				{lng: 6.1620083, lat: 49.842143999999998},
				{lng: 6.1619205, lat: 49.842132999999997},
				{lng: 6.161867, lat: 49.842112999999998},
				{lng: 6.161829, lat: 49.842101999999997},
				{lng: 6.1617336, lat: 49.842044999999999},
				{lng: 6.161539, lat: 49.84196},
				{lng: 6.1614895, lat: 49.841934000000002},
				{lng: 6.1614475, lat: 49.841904},
				{lng: 6.161398, lat: 49.841853999999998},
				{lng: 6.1613865, lat: 49.841850000000001},
				{lng: 6.161375, lat: 49.841850000000001},
				{lng: 6.161337, lat: 49.841853999999998},
				{lng: 6.161318, lat: 49.841845999999997},
				{lng: 6.1613064, lat: 49.841835000000003},
				{lng: 6.1612873, lat: 49.841811999999997},
				{lng: 6.1612606, lat: 49.841793000000003},
				{lng: 6.1612034, lat: 49.841763},
				{lng: 6.161154, lat: 49.841735999999997},
				{lng: 6.1611347, lat: 49.841704999999997},
				{lng: 6.1611156, lat: 49.841693999999997},
				{lng: 6.161104, lat: 49.841686000000003},
				{lng: 6.1610737, lat: 49.841686000000003},
				{lng: 6.1610126, lat: 49.841681999999999},
				{lng: 6.160986, lat: 49.841670000000001},
				{lng: 6.1609707, lat: 49.841644000000002},
				{lng: 6.160948, lat: 49.841619999999999},
				{lng: 6.1609325, lat: 49.841617999999997},
				{lng: 6.160906, lat: 49.841630000000002},
				{lng: 6.1608715, lat: 49.841636999999999},
				{lng: 6.160845, lat: 49.841625000000001},
				{lng: 6.1607265, lat: 49.841552999999998},
				{lng: 6.160658, lat: 49.84151},
				{lng: 6.1605663, lat: 49.841470000000001},
				{lng: 6.1603413, lat: 49.841366000000001},
				{lng: 6.1602345, lat: 49.841312000000002},
				{lng: 6.160185, lat: 49.841270000000002},
				{lng: 6.160162, lat: 49.841254999999997},
				{lng: 6.1600704, lat: 49.841231999999998},
				{lng: 6.159994, lat: 49.841189999999997},
				{lng: 6.159933, lat: 49.841166999999999},
				{lng: 6.1598873, lat: 49.841152000000001},
				{lng: 6.159834, lat: 49.84111},
				{lng: 6.1598034, lat: 49.841090000000001},
				{lng: 6.1597767, lat: 49.841076000000001},
				{lng: 6.1597385, lat: 49.841059999999999},
				{lng: 6.1597004, lat: 49.841034000000001},
				{lng: 6.1596622, lat: 49.841014999999999},
				{lng: 6.159624, lat: 49.840992},
				{lng: 6.159544, lat: 49.840958000000001},
				{lng: 6.159464, lat: 49.840919999999997},
				{lng: 6.159418, lat: 49.840890000000002},
				{lng: 6.1593685, lat: 49.840846999999997},
				{lng: 6.1593533, lat: 49.840789999999998},
				{lng: 6.1592083, lat: 49.840736},
				{lng: 6.159189, lat: 49.840719999999997},
				{lng: 6.1591663, lat: 49.840705999999997},
				{lng: 6.1590595, lat: 49.840649999999997},
				{lng: 6.159033, lat: 49.840609999999998},
				{lng: 6.1590176, lat: 49.840589999999999},
				{lng: 6.158949, lat: 49.840560000000004},
				{lng: 6.1589108, lat: 49.840539999999997},
				{lng: 6.1588917, lat: 49.840519999999998},
				{lng: 6.158861, lat: 49.840491999999998},
				{lng: 6.1587887, lat: 49.840446},
				{lng: 6.158758, lat: 49.840404999999997},
				{lng: 6.158716, lat: 49.840373999999997},
				{lng: 6.158655, lat: 49.840342999999997},
				{lng: 6.158613, lat: 49.840305000000001},
				{lng: 6.158514, lat: 49.840249999999997},
				{lng: 6.1584034, lat: 49.840150000000001},
				{lng: 6.1583195, lat: 49.840076000000003},
				{lng: 6.158247, lat: 49.840023000000002},
				{lng: 6.158209, lat: 49.840004},
				{lng: 6.1579227, lat: 49.839916000000002},
				{lng: 6.157755, lat: 49.839835999999998},
				{lng: 6.1573887, lat: 49.839652999999998},
				{lng: 6.157007, lat: 49.839478},
				{lng: 6.156809, lat: 49.839393999999999},
				{lng: 6.1566067, lat: 49.839314000000002},
				{lng: 6.1563587, lat: 49.839221999999999},
				{lng: 6.1561413, lat: 49.839149999999997},
				{lng: 6.1558475, lat: 49.839066000000003},
				{lng: 6.155817, lat: 49.83905},
				{lng: 6.1555233, lat: 49.839460000000003},
				{lng: 6.155493, lat: 49.839449999999999},
				{lng: 6.1547565, lat: 49.839194999999997},
				{lng: 6.154421, lat: 49.839077000000003},
				{lng: 6.154196, lat: 49.838979999999999},
				{lng: 6.153902, lat: 49.838850000000001},
				{lng: 6.153536, lat: 49.838650000000001},
				{lng: 6.1529026, lat: 49.838509999999999},
				{lng: 6.152239, lat: 49.838363999999999},
				{lng: 6.1522617, lat: 49.838272000000003},
				{lng: 6.152323, lat: 49.838042999999999},
				{lng: 6.152418, lat: 49.837707999999999},
				{lng: 6.1524906, lat: 49.837440000000001},
				{lng: 6.152506, lat: 49.837359999999997},
				{lng: 6.152521, lat: 49.837325999999997},
				{lng: 6.152769, lat: 49.836869999999998},
				{lng: 6.152895, lat: 49.836624},
				{lng: 6.153002, lat: 49.835810000000002},
				{lng: 6.152853, lat: 49.83531},
				{lng: 6.152746, lat: 49.834960000000002},
				{lng: 6.152445, lat: 49.835003},
				{lng: 6.152361, lat: 49.835014000000001},
				{lng: 6.1517506, lat: 49.835101999999999},
				{lng: 6.150694, lat: 49.835247000000003},
				{lng: 6.149626, lat: 49.835396000000003},
				{lng: 6.148649, lat: 49.835526000000002},
				{lng: 6.147585, lat: 49.835673999999997},
				{lng: 6.146742, lat: 49.835793000000002},
				{lng: 6.1455173, lat: 49.835963999999997},
				{lng: 6.144449, lat: 49.836109999999998},
				{lng: 6.143244, lat: 49.83625},
				{lng: 6.143217, lat: 49.836266000000002},
				{lng: 6.1432095, lat: 49.836277000000003},
				{lng: 6.1432095, lat: 49.836303999999998},
				{lng: 6.1432247, lat: 49.836314999999999},
				{lng: 6.14324, lat: 49.836334000000001},
				{lng: 6.14324, lat: 49.836345999999999},
				{lng: 6.1432247, lat: 49.836365000000001},
				{lng: 6.143221, lat: 49.836387999999999},
				{lng: 6.143236, lat: 49.836399999999998},
				{lng: 6.1432667, lat: 49.836413999999998},
				{lng: 6.143282, lat: 49.836436999999997},
				{lng: 6.143297, lat: 49.836449999999999},
				{lng: 6.143305, lat: 49.836460000000002},
				{lng: 6.1433125, lat: 49.836475},
				{lng: 6.1433277, lat: 49.836486999999998},
				{lng: 6.143343, lat: 49.836486999999998},
				{lng: 6.1433697, lat: 49.836489999999998},
				{lng: 6.1433926, lat: 49.836500000000001},
				{lng: 6.143408, lat: 49.836509999999997},
				{lng: 6.143442, lat: 49.83652},
				{lng: 6.143461, lat: 49.836536000000002},
				{lng: 6.1434803, lat: 49.836554999999997},
				{lng: 6.143488, lat: 49.83661},
				{lng: 6.143484, lat: 49.83663},
				{lng: 6.1434765, lat: 49.836649999999999},
				{lng: 6.1434727, lat: 49.836666000000001},
				{lng: 6.1434803, lat: 49.836680000000001},
				{lng: 6.1435146, lat: 49.836709999999997},
				{lng: 6.1434956, lat: 49.836742000000001},
				{lng: 6.1434803, lat: 49.836750000000002},
				{lng: 6.143484, lat: 49.836759999999998},
				{lng: 6.1435146, lat: 49.836790000000001},
				{lng: 6.1435337, lat: 49.836796},
				{lng: 6.143564, lat: 49.836796},
				{lng: 6.1436024, lat: 49.836792000000003},
				{lng: 6.143629, lat: 49.836792000000003},
				{lng: 6.1436596, lat: 49.836803000000003},
				{lng: 6.1436825, lat: 49.836829999999999},
				{lng: 6.1436977, lat: 49.836849999999998},
				{lng: 6.1437244, lat: 49.836869999999998},
				{lng: 6.1437473, lat: 49.836903},
				{lng: 6.143751, lat: 49.836917999999997},
				{lng: 6.143759, lat: 49.836939999999998},
				{lng: 6.14377, lat: 49.836964000000002},
				{lng: 6.143797, lat: 49.837006000000002},
				{lng: 6.143793, lat: 49.837032000000001},
				{lng: 6.143793, lat: 49.837043999999999},
				{lng: 6.143816, lat: 49.837063000000001},
				{lng: 6.1438503, lat: 49.837097},
				{lng: 6.1438656, lat: 49.837128},
				{lng: 6.1438923, lat: 49.837310000000002},
				{lng: 6.143881, lat: 49.837333999999998},
				{lng: 6.143854, lat: 49.837359999999997},
				{lng: 6.1438465, lat: 49.837383000000003},
				{lng: 6.1438503, lat: 49.837400000000002},
				{lng: 6.1438313, lat: 49.837409999999998},
				{lng: 6.1438313, lat: 49.837420000000002},
				{lng: 6.143835, lat: 49.837463},
				{lng: 6.143835, lat: 49.837513000000001},
				{lng: 6.1438046, lat: 49.837563000000003},
				{lng: 6.1438046, lat: 49.837597000000002},
				{lng: 6.143793, lat: 49.83764},
				{lng: 6.1437626, lat: 49.837670000000003},
				{lng: 6.143751, lat: 49.837679999999999},
				{lng: 6.143751, lat: 49.837704000000002},
				{lng: 6.143759, lat: 49.837739999999997},
				{lng: 6.1437435, lat: 49.837764999999997},
				{lng: 6.143667, lat: 49.837864000000003},
				{lng: 6.1436405, lat: 49.837902},
				{lng: 6.143633, lat: 49.837919999999997},
				{lng: 6.143656, lat: 49.837960000000002},
				{lng: 6.143656, lat: 49.837989999999998},
				{lng: 6.143652, lat: 49.838030000000003},
				{lng: 6.143667, lat: 49.838050000000003},
				{lng: 6.1436977, lat: 49.838079999999998},
				{lng: 6.143713, lat: 49.838104000000001},
				{lng: 6.1437054, lat: 49.83813},
				{lng: 6.1437016, lat: 49.838146000000002},
				{lng: 6.143713, lat: 49.838169999999998},
				{lng: 6.143736, lat: 49.838180000000001},
				{lng: 6.143797, lat: 49.838203},
				{lng: 6.1438236, lat: 49.838230000000003},
				{lng: 6.1438465, lat: 49.838272000000003},
				{lng: 6.143862, lat: 49.838290000000001},
				{lng: 6.143877, lat: 49.838295000000002},
				{lng: 6.1439075, lat: 49.838303000000003},
				{lng: 6.143938, lat: 49.838332999999999},
				{lng: 6.1439724, lat: 49.838383},
				{lng: 6.1440144, lat: 49.838417},
				{lng: 6.1440296, lat: 49.838444000000003},
				{lng: 6.1440296, lat: 49.838478000000002},
				{lng: 6.1439724, lat: 49.838524},
				{lng: 6.1440105, lat: 49.838695999999999},
				{lng: 6.144182, lat: 49.839354999999998},
				{lng: 6.1442204, lat: 49.839489999999998},
				{lng: 6.144148, lat: 49.839717999999998},
				{lng: 6.1459827, lat: 49.840218},
				{lng: 6.1463604, lat: 49.840319999999998},
				{lng: 6.1472874, lat: 49.840564999999998},
				{lng: 6.1480694, lat: 49.840755000000001},
				{lng: 6.148752, lat: 49.840927000000001},
				{lng: 6.1495724, lat: 49.841124999999998},
				{lng: 6.1508083, lat: 49.841557000000002},
				{lng: 6.1508694, lat: 49.84158},
				{lng: 6.151167, lat: 49.84178},
				{lng: 6.151533, lat: 49.842039999999997},
				{lng: 6.151621, lat: 49.842075000000001},
				{lng: 6.1516666, lat: 49.842154999999998},
				{lng: 6.1516895, lat: 49.842185999999998},
				{lng: 6.151949, lat: 49.842551999999998},
				{lng: 6.152151, lat: 49.842823000000003},
				{lng: 6.1522694, lat: 49.842970000000001},
				{lng: 6.1525745, lat: 49.843314999999997},
				{lng: 6.152872, lat: 49.843643},
				{lng: 6.15304, lat: 49.843829999999997},
				{lng: 6.153059, lat: 49.843870000000003},
				{lng: 6.1530704, lat: 49.843913999999998},
				{lng: 6.1530857, lat: 49.844273000000001},
				{lng: 6.1530704, lat: 49.844329999999999},
				{lng: 6.1528378, lat: 49.844883000000003},
				{lng: 6.1528225, lat: 49.844917000000002},
				{lng: 6.152857, lat: 49.844929999999998},
				{lng: 6.153166, lat: 49.845055000000002},
				{lng: 6.153269, lat: 49.845219999999998},
				{lng: 6.153219, lat: 49.845253},
				{lng: 6.1533146, lat: 49.845419999999997},
				{lng: 6.1534214, lat: 49.845646000000002},
				{lng: 6.153471, lat: 49.845776000000001},
				{lng: 6.1535206, lat: 49.845962999999998},
				{lng: 6.153532, lat: 49.846080000000001},
				{lng: 6.153532, lat: 49.84619},
				{lng: 6.153517, lat: 49.846386000000003},
				{lng: 6.153494, lat: 49.846541999999999},
				{lng: 6.153467, lat: 49.846705999999998},
				{lng: 6.1534367, lat: 49.846850000000003},
				{lng: 6.1533794, lat: 49.847042000000002},
				{lng: 6.1533337, lat: 49.847189999999998},
				{lng: 6.1532993, lat: 49.847275000000003},
				{lng: 6.153158, lat: 49.847282},
				{lng: 6.1523647, lat: 49.848100000000002},
				{lng: 6.152441, lat: 49.848137000000001},
				{lng: 6.1521664, lat: 49.848457000000003},
				{lng: 6.151865, lat: 49.848750000000003},
				{lng: 6.151621, lat: 49.848934},
				{lng: 6.1515713, lat: 49.848903999999997},
				{lng: 6.1515293, lat: 49.848877000000002},
				{lng: 6.1508617, lat: 49.849518000000003},
				{lng: 6.1506176, lat: 49.849742999999997},
				{lng: 6.1503124, lat: 49.850014000000002},
				{lng: 6.1497173, lat: 49.850524999999998},
				{lng: 6.1493626, lat: 49.850802999999999},
				{lng: 6.148855, lat: 49.851165999999999},
				{lng: 6.1483707, lat: 49.851494000000002},
				{lng: 6.1482105, lat: 49.851790000000001},
				{lng: 6.148138, lat: 49.851894000000001},
				{lng: 6.147173, lat: 49.852195999999999},
				{lng: 6.1467686, lat: 49.852317999999997},
				{lng: 6.1467457, lat: 49.852336899999997},
				{lng: 6.1466656, lat: 49.852336899999997},
				{lng: 6.1466045, lat: 49.8523669},
				{lng: 6.1465282, lat: 49.852424900000003},
				{lng: 6.1464214, lat: 49.852519899999997},
				{lng: 6.1464176, lat: 49.852572899999998},
				{lng: 6.146414, lat: 49.852669900000002},
				{lng: 6.1464252, lat: 49.852809899999997},
				{lng: 6.1464634, lat: 49.852929899999999},
				{lng: 6.1465282, lat: 49.853045899999998},
				{lng: 6.146658, lat: 49.853219899999999},
				{lng: 6.1468677, lat: 49.853492899999999},
				{lng: 6.1469819, lat: 49.853659899999997},
				{lng: 6.1471349, lat: 49.853929899999997},
				{lng: 6.1472339, lat: 49.8540499},
				{lng: 6.1473826, lat: 49.854194900000003},
				{lng: 6.1474819, lat: 49.8543199},
				{lng: 6.1475505, lat: 49.8544239},
				{lng: 6.1476839, lat: 49.854649899999998},
				{lng: 6.1477259, lat: 49.854729900000002},
				{lng: 6.1478519, lat: 49.8549899},
				{lng: 6.1480539, lat: 49.855359900000003},
				{lng: 6.1481569, lat: 49.855519899999997},
				{lng: 6.1482179, lat: 49.855619900000001},
				{lng: 6.1482524, lat: 49.855799900000001},
				{lng: 6.1482829, lat: 49.855903900000001},
				{lng: 6.1484012, lat: 49.856169899999998},
				{lng: 6.1485539, lat: 49.856463900000001},
				{lng: 6.1487216, lat: 49.856784900000001},
				{lng: 6.1490344, lat: 49.857337899999997},
				{lng: 6.1489849, lat: 49.8573199},
				{lng: 6.1485652, lat: 49.857019899999997},
				{lng: 6.1484775, lat: 49.856963899999997},
				{lng: 6.1481875, lat: 49.856749899999997},
				{lng: 6.1479205, lat: 49.856555899999996},
				{lng: 6.1475429, lat: 49.856833899999998},
				{lng: 6.1471119, lat: 49.857142899999999},
				{lng: 6.1468944, lat: 49.857284900000003},
				{lng: 6.1467914, lat: 49.857345899999999},
				{lng: 6.1466959, lat: 49.857399899999997},
				{lng: 6.1462916, lat: 49.857612899999999},
				{lng: 6.1461579, lat: 49.857689899999997},
				{lng: 6.1459749, lat: 49.857799900000003},
				{lng: 6.1453569, lat: 49.858179900000003},
				{lng: 6.1453759, lat: 49.858191900000001},
				{lng: 6.1451625, lat: 49.858319899999998},
				{lng: 6.1450329, lat: 49.858309900000002},
				{lng: 6.1449109, lat: 49.858314900000003},
				{lng: 6.1448079, lat: 49.858329900000001},
				{lng: 6.1447505, lat: 49.8583529},
				{lng: 6.1447085, lat: 49.858375899999999},
				{lng: 6.1446704, lat: 49.858386899999999},
				{lng: 6.1446246, lat: 49.858386899999999},
				{lng: 6.1446019, lat: 49.858389899999999},
				{lng: 6.1445826, lat: 49.858405900000001},
				{lng: 6.1445409, lat: 49.858462899999999},
				{lng: 6.1445254, lat: 49.858474899999997},
				{lng: 6.1444873, lat: 49.858493899999999},
				{lng: 6.1443614, lat: 49.858523900000002},
				{lng: 6.1441592, lat: 49.858981900000003},
				{lng: 6.1439649, lat: 49.858996900000001},
				{lng: 6.1439303, lat: 49.859023899999997},
				{lng: 6.1439074, lat: 49.859039899999999},
				{lng: 6.1438426, lat: 49.859089900000001},
				{lng: 6.1437243, lat: 49.859172899999997},
				{lng: 6.1435489, lat: 49.859302900000003},
				{lng: 6.1433049, lat: 49.859477900000002},
				{lng: 6.1432246, lat: 49.8595349},
				{lng: 6.1429843, lat: 49.859702900000002},
				{lng: 6.1429539, lat: 49.859725900000001},
				{lng: 6.1428584, lat: 49.859789900000003},
				{lng: 6.1428239, lat: 49.859813899999999},
				{lng: 6.1427479, lat: 49.8598699},
				{lng: 6.1423282, lat: 49.860169900000002},
				{lng: 6.1422595, lat: 49.860217900000002},
				{lng: 6.1421832, lat: 49.8602749},
				{lng: 6.1421374, lat: 49.8603059},
				{lng: 6.1418323, lat: 49.860526900000004},
				{lng: 6.1414164, lat: 49.860819900000003},
				{lng: 6.1413745, lat: 49.860846899999999},
				{lng: 6.1412679, lat: 49.860923900000003},
				{lng: 6.1412105, lat: 49.8609619},
				{lng: 6.1410235, lat: 49.8608549},
				{lng: 6.1408214, lat: 49.861009899999999},
				{lng: 6.1406802, lat: 49.861121900000001},
				{lng: 6.1406039, lat: 49.8611699},
				{lng: 6.1405239, lat: 49.861224900000003},
				{lng: 6.1405009, lat: 49.861239900000001},
				{lng: 6.1403674, lat: 49.861323900000002},
				{lng: 6.1401079, lat: 49.8615529},
				{lng: 6.1404629, lat: 49.861709900000001},
				{lng: 6.1409319, lat: 49.861919899999997},
				{lng: 6.1407336, lat: 49.862099899999997},
				{lng: 6.1403064, lat: 49.8624729},
				{lng: 6.1401004, lat: 49.862649900000001},
				{lng: 6.1402606, lat: 49.8627319},
				{lng: 6.1399783, lat: 49.862969900000003},
				{lng: 6.1398029, lat: 49.863105900000001},
				{lng: 6.1393489, lat: 49.863452899999999},
				{lng: 6.1383569, lat: 49.862969900000003},
				{lng: 6.1380559, lat: 49.862822899999998},
				{lng: 6.1378154, lat: 49.862716900000002},
				{lng: 6.1376285, lat: 49.862639899999998},
				{lng: 6.1372469, lat: 49.862479899999997},
				{lng: 6.1368769, lat: 49.862609900000002},
				{lng: 6.1362019, lat: 49.862849900000001},
				{lng: 6.1360949, lat: 49.862879900000003},
				{lng: 6.1359959, lat: 49.862899900000002},
				{lng: 6.1358203, lat: 49.8629259},
				{lng: 6.1357629, lat: 49.862933900000002},
				{lng: 6.1357019, lat: 49.862939900000001},
				{lng: 6.1347369, lat: 49.863101899999997},
				{lng: 6.1347409, lat: 49.863419899999997},
				{lng: 6.1347329, lat: 49.863529900000003},
				{lng: 6.1347179, lat: 49.863585899999997},
				{lng: 6.1347026, lat: 49.863619900000003},
				{lng: 6.1346683, lat: 49.863669899999998},
				{lng: 6.1346149, lat: 49.8637199},
				{lng: 6.1344509, lat: 49.863845900000001},
				{lng: 6.1342869, lat: 49.863711899999998},
				{lng: 6.1341113, lat: 49.863582899999997},
				{lng: 6.1335124, lat: 49.863456900000003},
				{lng: 6.1331959, lat: 49.8634719},
				{lng: 6.1328525, lat: 49.863499900000001},
				{lng: 6.1328409, lat: 49.863499900000001},
				{lng: 6.1321506, lat: 49.863563900000003},
				{lng: 6.1319255, lat: 49.863593899999998},
				{lng: 6.1313533, lat: 49.863662900000001},
				{lng: 6.1311589, lat: 49.863689899999997},
				{lng: 6.1308993, lat: 49.863723899999997},
				{lng: 6.1306629, lat: 49.863759899999998},
				{lng: 6.1304529, lat: 49.863784899999999},
				{lng: 6.1302623, lat: 49.863803900000001},
				{lng: 6.1303386, lat: 49.864066899999997},
				{lng: 6.1303615, lat: 49.864159899999997},
				{lng: 6.1304339, lat: 49.864467900000001},
				{lng: 6.1304989, lat: 49.8647499},
				{lng: 6.1305409, lat: 49.8649749},
				{lng: 6.1305865, lat: 49.865159900000002},
				{lng: 6.1306779, lat: 49.865409900000003},
				{lng: 6.1307086, lat: 49.865455900000001},
				{lng: 6.1308499, lat: 49.865737899999999},
				{lng: 6.1309184, lat: 49.8658699},
				{lng: 6.1309449, lat: 49.865916900000002},
				{lng: 6.1310023, lat: 49.866009900000002},
				{lng: 6.1310634, lat: 49.866103899999999},
				{lng: 6.1311206, lat: 49.8661879},
				{lng: 6.1311816, lat: 49.866271900000001},
				{lng: 6.1313039, lat: 49.866435899999999},
				{lng: 6.1314409, lat: 49.866614900000002},
				{lng: 6.1315783, lat: 49.8668099},
				{lng: 6.1317195, lat: 49.867049899999998},
				{lng: 6.1318072, lat: 49.867249899999997},
				{lng: 6.1318416, lat: 49.867362900000003},
				{lng: 6.1319329, lat: 49.867766899999999},
				{lng: 6.1319559, lat: 49.867927899999998},
				{lng: 6.1319713, lat: 49.868119900000003},
				{lng: 6.1319713, lat: 49.868262899999998},
				{lng: 6.1319674, lat: 49.868389899999997},
				{lng: 6.1320056, lat: 49.868392900000003},
				{lng: 6.1319369, lat: 49.868819899999998},
				{lng: 6.1319446, lat: 49.868919900000002},
				{lng: 6.1319674, lat: 49.869071900000002},
				{lng: 6.1319789, lat: 49.869129899999997},
				{lng: 6.1320552, lat: 49.869445900000002},
				{lng: 6.1320552, lat: 49.869459900000003},
				{lng: 6.1320629, lat: 49.869479900000002},
				{lng: 6.1322535, lat: 49.869599899999997},
				{lng: 6.1323069, lat: 49.869632899999999},
				{lng: 6.1323679, lat: 49.8696859},
				{lng: 6.1324214, lat: 49.869746900000003},
				{lng: 6.1324559, lat: 49.869796899999997},
				{lng: 6.1324749, lat: 49.869839900000002},
				{lng: 6.1324862, lat: 49.869889899999997},
				{lng: 6.1324979, lat: 49.8699759},
				{lng: 6.1324939, lat: 49.8699899},
				{lng: 6.1324899, lat: 49.8700519},
				{lng: 6.1324709, lat: 49.870131899999997},
				{lng: 6.1323756, lat: 49.870357900000002},
				{lng: 6.1323069, lat: 49.870494899999997},
				{lng: 6.1321315, lat: 49.870803899999999},
				{lng: 6.1320285, lat: 49.8710059},
				{lng: 6.1320056, lat: 49.871009899999997},
				{lng: 6.1319865, lat: 49.871009899999997},
				{lng: 6.1317119, lat: 49.871059899999999},
				{lng: 6.1315974, lat: 49.871066900000002},
				{lng: 6.1315402, lat: 49.871066900000002},
				{lng: 6.1314982, lat: 49.871055900000002},
				{lng: 6.1313266, lat: 49.870969899999999},
				{lng: 6.1312999, lat: 49.870986899999998},
				{lng: 6.1311397, lat: 49.8710819},
				{lng: 6.1309184, lat: 49.871211899999999},
				{lng: 6.1307199, lat: 49.871333900000003},
				{lng: 6.1303349, lat: 49.871562900000001},
				{lng: 6.1302279, lat: 49.871623900000003},
				{lng: 6.1301135, lat: 49.8717039},
				{lng: 6.1299839, lat: 49.871787900000001},
				{lng: 6.1298809, lat: 49.871849900000001},
				{lng: 6.1296672, lat: 49.871982899999999},
				{lng: 6.1295985, lat: 49.872019899999998},
				{lng: 6.1295869, lat: 49.872029900000001},
				{lng: 6.130865, lat: 49.874362900000001},
				{lng: 6.131628, lat: 49.875731899999998},
				{lng: 6.1315556, lat: 49.875729900000003},
				{lng: 6.1315403, lat: 49.875729900000003},
				{lng: 6.1308613, lat: 49.875686899999998},
				{lng: 6.130419, lat: 49.875659900000002},
				{lng: 6.13035, lat: 49.875663899999999},
				{lng: 6.130213, lat: 49.875693900000002},
				{lng: 6.130087, lat: 49.875724900000002},
				{lng: 6.1297473, lat: 49.875909900000003},
				{lng: 6.1295604, lat: 49.876002900000003},
				{lng: 6.1293619, lat: 49.876089899999997},
				{lng: 6.1291903, lat: 49.876166900000001},
				{lng: 6.1291102, lat: 49.876209899999999},
				{lng: 6.1289882, lat: 49.876277899999998},
				{lng: 6.1289004, lat: 49.876315900000002},
				{lng: 6.1285304, lat: 49.876449899999997},
				{lng: 6.1284809, lat: 49.876483899999997},
				{lng: 6.1283399, lat: 49.876594900000001},
				{lng: 6.1281909, lat: 49.876723900000002},
				{lng: 6.1281222, lat: 49.876799900000002},
				{lng: 6.1280574, lat: 49.876859899999999},
				{lng: 6.1280039, lat: 49.876895900000001},
				{lng: 6.1278589, lat: 49.876975899999998},
				{lng: 6.1277179, lat: 49.877049900000003},
				{lng: 6.1273936, lat: 49.877212900000004},
				{lng: 6.1272599, lat: 49.877276899999998},
				{lng: 6.1271686, lat: 49.8773099},
				{lng: 6.1270846, lat: 49.8773269},
				{lng: 6.1269206, lat: 49.877345900000002},
				{lng: 6.1267833, lat: 49.877353900000003},
				{lng: 6.1266955, lat: 49.877349899999999},
				{lng: 6.1266154, lat: 49.877334900000001},
				{lng: 6.1264779, lat: 49.8772929},
				{lng: 6.1256503, lat: 49.877463900000002},
				{lng: 6.1254443, lat: 49.877234899999998},
				{lng: 6.1253719, lat: 49.877173900000003},
				{lng: 6.1253069, lat: 49.8771299},
				{lng: 6.1252612, lat: 49.877097900000003},
				{lng: 6.1252269, lat: 49.877079899999998},
				{lng: 6.1251659, lat: 49.877049900000003},
				{lng: 6.1251199, lat: 49.877029899999997},
				{lng: 6.1250285, lat: 49.8769949},
				{lng: 6.1248912, lat: 49.876964899999997},
				{lng: 6.1247195, lat: 49.876922899999997},
				{lng: 6.1246242, lat: 49.876903900000002},
				{lng: 6.1245249, lat: 49.876872900000002},
				{lng: 6.1243799, lat: 49.876822900000001},
				{lng: 6.1242122, lat: 49.876759900000003},
				{lng: 6.1239795, lat: 49.8766599},
				{lng: 6.1238499, lat: 49.876613900000002},
				{lng: 6.1236859, lat: 49.876563900000001},
				{lng: 6.1234989, lat: 49.876727899999999},
				{lng: 6.1232623, lat: 49.876925900000003},
				{lng: 6.1231746, lat: 49.8769949},
				{lng: 6.1231135, lat: 49.8770399},
				{lng: 6.1230409, lat: 49.877074899999997},
				{lng: 6.1229762, lat: 49.877097900000003},
				{lng: 6.1229266, lat: 49.877109900000001},
				{lng: 6.1227893, lat: 49.877124899999998},
				{lng: 6.1227319, lat: 49.877124899999998},
				{lng: 6.1222629, lat: 49.877135899999999},
				{lng: 6.1222249, lat: 49.877082899999998},
				{lng: 6.1221026, lat: 49.876922899999997},
				{lng: 6.1218049, lat: 49.876712900000001},
				{lng: 6.1212559, lat: 49.876709900000002},
				{lng: 6.1210002, lat: 49.876709900000002},
				{lng: 6.1201114, lat: 49.876922899999997},
				{lng: 6.1201076, lat: 49.876872900000002},
				{lng: 6.1200389, lat: 49.876826899999998},
				{lng: 6.1193255, lat: 49.876334900000003},
				{lng: 6.1190279, lat: 49.876235899999998},
				{lng: 6.1187953, lat: 49.876166900000001},
				{lng: 6.1185206, lat: 49.8764149},
				{lng: 6.1183299, lat: 49.876582900000002},
				{lng: 6.1181279, lat: 49.8767499},
				{lng: 6.1181125, lat: 49.876761899999998},
				{lng: 6.1180896, lat: 49.8767779},
				{lng: 6.1180629, lat: 49.876799900000002},
				{lng: 6.1176433, lat: 49.877109900000001},
				{lng: 6.1175289, lat: 49.877189899999998},
				{lng: 6.1175709, lat: 49.877499899999997},
				{lng: 6.1176089, lat: 49.877839899999998},
				{lng: 6.1176433, lat: 49.878099900000002},
				{lng: 6.1176509, lat: 49.878161900000002},
				{lng: 6.1176739, lat: 49.878364900000001},
				{lng: 6.1176852, lat: 49.8784499},
				{lng: 6.1176969, lat: 49.878524900000002},
				{lng: 6.1178189, lat: 49.878579899999998},
				{lng: 6.1180589, lat: 49.878889899999997},
				{lng: 6.1182803, lat: 49.879207899999997},
				{lng: 6.1184559, lat: 49.8794629},
				{lng: 6.1184939, lat: 49.879529900000001},
				{lng: 6.1185399, lat: 49.879629899999998},
				{lng: 6.1185626, lat: 49.879703900000003},
				{lng: 6.1185739, lat: 49.879786899999999},
				{lng: 6.1185893, lat: 49.879886900000002},
				{lng: 6.1185512, lat: 49.880209899999997},
				{lng: 6.1185169, lat: 49.880431899999998},
				{lng: 6.1185169, lat: 49.880465899999997},
				{lng: 6.1185319, lat: 49.880609900000003},
				{lng: 6.1185702, lat: 49.880839899999998},
				{lng: 6.1186923, lat: 49.881316900000002},
				{lng: 6.1187799, lat: 49.881625900000003},
				{lng: 6.1188182, lat: 49.881749900000003},
				{lng: 6.1189555, lat: 49.881972900000001},
				{lng: 6.1191579, lat: 49.882293900000001},
				{lng: 6.1194133, lat: 49.882679899999999},
				{lng: 6.1196002, lat: 49.882964899999997},
				{lng: 6.1199626, lat: 49.883521899999998},
				{lng: 6.1199855, lat: 49.883569899999998},
				{lng: 6.1200084, lat: 49.8836899},
				{lng: 6.1200429, lat: 49.8838899},
				{lng: 6.1200769, lat: 49.884196899999999},
				{lng: 6.1200465, lat: 49.884439899999997},
				{lng: 6.1199893, lat: 49.884789900000001},
				{lng: 6.1199399, lat: 49.885066899999998},
				{lng: 6.1198825, lat: 49.885432899999998},
				{lng: 6.1198672, lat: 49.885592899999999},
				{lng: 6.1198596, lat: 49.885789899999999},
				{lng: 6.1198596, lat: 49.885909900000001},
				{lng: 6.1198863, lat: 49.8859979},
				{lng: 6.1199283, lat: 49.8861159},
				{lng: 6.1199511, lat: 49.886169899999999},
				{lng: 6.1201495, lat: 49.886669900000001},
				{lng: 6.1202259, lat: 49.886786899999997},
				{lng: 6.1202945, lat: 49.8868869},
				{lng: 6.1204204, lat: 49.887053899999998},
				{lng: 6.1205349, lat: 49.887195900000002},
				{lng: 6.1206492, lat: 49.887324900000003},
				{lng: 6.1207942, lat: 49.887534899999999},
				{lng: 6.1208896, lat: 49.887855899999998},
				{lng: 6.1209429, lat: 49.888053900000003},
				{lng: 6.1209699, lat: 49.8881649},
				{lng: 6.1210422, lat: 49.888526900000002},
				{lng: 6.1212369, lat: 49.888854899999998},
				{lng: 6.1213435, lat: 49.889009899999998},
				{lng: 6.1213929, lat: 49.889083900000003},
				{lng: 6.1216259, lat: 49.889179900000002},
				{lng: 6.1217859, lat: 49.889235900000003},
				{lng: 6.1219043, lat: 49.889279899999998},
				{lng: 6.1220719, lat: 49.889319899999997},
				{lng: 6.1221713, lat: 49.889339900000003},
				{lng: 6.1229839, lat: 49.889449900000002},
				{lng: 6.1238154, lat: 49.889569899999998},
				{lng: 6.1241092, lat: 49.889605899999999},
				{lng: 6.1241129, lat: 49.889719900000003},
				{lng: 6.1241319, lat: 49.890025899999998},
				{lng: 6.1241399, lat: 49.890349899999997},
				{lng: 6.1241509, lat: 49.890471900000001},
				{lng: 6.1241626, lat: 49.890529899999997},
				{lng: 6.1241816, lat: 49.890574899999997},
				{lng: 6.1242122, lat: 49.8906329},
				{lng: 6.1242694, lat: 49.890719900000001},
				{lng: 6.1243075, lat: 49.890761900000001},
				{lng: 6.1244029, lat: 49.8908269},
				{lng: 6.1244906, lat: 49.890872899999998},
				{lng: 6.1245899, lat: 49.890909899999997},
				{lng: 6.1246739, lat: 49.8909339},
				{lng: 6.1247539, lat: 49.890944900000001},
				{lng: 6.1250439, lat: 49.8909649},
				{lng: 6.1252116, lat: 49.890969900000002},
				{lng: 6.1254289, lat: 49.890971899999997},
				{lng: 6.1259709, lat: 49.890971899999997},
				{lng: 6.1260585, lat: 49.890959899999999},
				{lng: 6.1267449, lat: 49.890879900000002},
				{lng: 6.1272219, lat: 49.891869900000003},
				{lng: 6.1272869, lat: 49.892005900000001},
				{lng: 6.1273709, lat: 49.892215899999997},
				{lng: 6.1274319, lat: 49.892399900000001},
				{lng: 6.1274739, lat: 49.892573900000002},
				{lng: 6.1275119, lat: 49.892819899999999},
				{lng: 6.1275615, lat: 49.893309899999998},
				{lng: 6.1275539, lat: 49.893389900000003}
			];
			if (this.findGetParameter('placeID') !== null) {
				this.selectedPlace = this.findGetParameter('placeID');
				this.displayPlaceDetails();
				setTimeout((event) => {
					this.setMarkersOnMap();
				}, 2000);
			}
		}
	}

	getURL() {
		return URL.getUrlForAPI();
	}

	attachPlaceDetails(uid = false) {

		if (uid) {

			this.selectedPlace = uid;
			this.displayPlaceDetails();
			this.setMarkersOnMap();

		}
		else {

			let searchItem = $('.place-search-item');

			searchItem.each((index, element) => {

				let $element = $(element);

				$element.on('click', () => {
					this.selectedPlace = $element.data('uid');
					this.displayPlaceDetails();
					this.setMarkersOnMap();
				});

			});

		}
	}

	displayPlaceDetails() {
		let placeListContainer = $('.map-theme-container');

		if (($('.place-detail[data-uid=' + this.selectedPlace + ']').length === 0) || (this.findGetParameter('id'))) {

			let placeDetailsContainer = $('.map-info-block');
			let loader = placeDetailsContainer.find('.loader-area');
			let details = placeDetailsContainer.find('.content-area');
			let data = {
				action: 'place',
				uid: this.selectedPlace,
			};

			if (this.useMyPosition) {
				data.latitude = this.myPosition.lat;
				data.longitude = this.myPosition.lng;
			}

			$.ajax({
				url: this.getURL(),
				type: 'GET',
				data: data,
				beforeSend: () => {
					placeDetailsContainer.addClass('displayed');
					placeListContainer.addClass('hidden');
					loader.removeClass('hidden');
					details.addClass('hidden');
				},
				success: (data) => {
					let place = new Place(data);
					place.render();

					loader.addClass('hidden');
					details.removeClass('hidden');

					setTimeout(() => {
						$('.map-info-block').find('.content-area').css('opacity', '1');
					}, 300);

					$('.info-close').on('click', () => {
						placeDetailsContainer.removeClass('displayed');
						placeListContainer.removeClass('hidden');
						$('.content-area').addClass('hidden');
						setTimeout(() => {
							details.addClass('hidden');
						}, 300);
						setTimeout(() => {
							$('.map-info-block').find('.content-area').css('opacity', '0');
						}, 300);

						let markersArray = [];
						markersArray['no-coordinates'] = [];
						if (this.samePlaceList && this.samePlaceList.length >= 2) {
							$.each(this.samePlaceList, (aIndex, aPlace) => {
								this.selectedPlace = aPlace.uid;
								this.setMarkersOnMap();
							})
						}
						else {
							this.selectedPlace = false;
							this.setMarkersOnMap();
						}

					});
				}
			});
		}

		if (this.isMobile()) {
		}
	}

	attachPlaceListAndMap() {
		this.selectedPlace = false;
		let url = this.getURL() + "?action=place&tags=" + this.tags;
		let loader = $('.map-theme-container .loader-area');
		$('.suggestions-list').html('');
		loader.removeClass('hidden');

		$.get(url, (placeList) => {
			loader.addClass('hidden');
			this.placeList = placeList;
			this.attachPlaceList();
			this.attachMap();
		});
	}

	attachPlaceList(samePoint = false, address = false) {
		let list = new AData(this.placeList);
		let arrPlaceList = [];

		$.each(list.getData(), (index, place) => {
			let aPlace = new AData(place);

			/*
             * Image
             */
			let image = ABuilder('div', {
				'class': 'suggestion-img',
				'style': 'background-image: url(' + aPlace.get('imageUrl') + ')'
			}, [
				''
			]);

			/*
             * Name
             */
			let name = ABuilder('div', {'class': 'suggestion-place'}, [
				aPlace.get('title')
			]);

			/*
             * Category
             */
			let category = ABuilder('div', {'class': 'suggestion-category'}, [
				aPlace.get('subCategoryName')
			]);

			arrPlaceList.push(
				ABuilder('div', {
					'class': 'suggestion place-search-item',
					'data-uid': aPlace.get('uid')
				}, [
					image,
					ABuilder('div', {
						'class': 'suggestion-text',
					}, [
						name,
						category
					])
				])
			);

		});

		$('.suggestions-list').html(arrPlaceList);

		if (samePoint) {
			$('.suggestions-list').prepend($('<div class="info-address"></div>')).prepend(
				$('<div class="same-point-close snookfun-icon snookfun-icon-close"></div>').on('click', (e) => {
					this.attachPlaceListAndMap();
					$('.map-theme-selector').removeClass('hidden');
				})
			);
		}

		if (address) {
			$('.info-address').html(address);
		}

		this.attachPlaceDetails();
	}

	attachMap() {
		let aMyPosition = new AData(this.myPosition);
		if (!aMyPosition.has('lat') || !aMyPosition.has('lng')) {
			this.myPosition = {lat: 49.866540, lng: 6.159361};
		}

		if (!this.map) {

			this.map = new google.maps.Map(document.getElementById('map'), {
				zoom: this.zoom,
				scrollwheel: false,
				zoomControl: true,
				mapTypeControl: false,
				scaleControl: false,
				streetViewControl: false,
				rotateControl: false,
				fullscreenControl: false,
				// mapTypeId: 'Styled'
			});

			this.mapFirstInit = true;

			this.map.addListener('idle', () => {
				if (this.mapFirstInit === true) {
					this.mapFirstInit = false;
					this.setMarkersOnMap();

					this.outlineDrawing = new google.maps.Polygon({
						paths: this.outline,
						strokeColor: '#0095dA',
						strokeOpacity: 0.8,
						strokeWeight: 3,
						fillColor: '#0095dA',
						fillOpacity: 0.15
					});

					this.outlineDrawing.setMap(this.map);
				}
			});

		} else {
			this.setMarkersOnMap();
		}

		this.map.panTo(new google.maps.LatLng(this.myPosition.lat, this.myPosition.lng));
		if (this.zoom !== this.map.getZoom()) {
			this.map.setZoom(this.zoom);
		}

		// let styles = [];
		// let styledMapType = new google.maps.StyledMapType(styles, {name: 'Styled'});
		// this.map.mapTypes.set('Styled', styledMapType);
		// wait til map has fully loaded before offsetting map
	}

	setMarkersOnMap() {
		let aMyPosition = new AData(this.myPosition);

		if (this.markers.length > 0) {
			for (let i = 0; i < this.markers.length; i++) {
				this.markers[i].setVisible(false);
			}
		}

		this.markers = [];

		let boundWithAllPlaces = new google.maps.LatLngBounds();
		//find coordinates with address
		let Geocoder = new google.maps.Geocoder;

		let markersArray = [];
		markersArray['no-coordinates'] = [];

		$.each(this.placeList, (index, place) => {
			if ((place.latitude) && (place.longitude)) {
				if ((markersArray[place.latitude + '-' + place.longitude] === null) || (markersArray[place.latitude + '-' + place.longitude] === undefined)) {
					markersArray[place.latitude + '-' + place.longitude] = [];
				}
				markersArray[place.latitude + '-' + place.longitude].push(place);
			}
			else {
				markersArray['no-coordinates'].push(place);
			}
		});

		// console.log(markersArray);
		// console.log(this.placeList);

		$.each(this.placeList, (index, place) => {
			let selected = false;
			if ((!place.latitude || !place.longitude) && (place.address1 && place.address2)) {
				Geocoder.geocode({
					address: place.address1 + ' ' + place.address2,
					componentRestrictions: {
						country: 'lu'
					}
				}, (results, status) => {
					if (status === 'OK') {
						place.latitude = results[0].geometry.location.lat();
						place.longitude = results[0].geometry.location.lng();
						this.placeList[index] = place;
					}
				});
			}

			if (place.latitude && place.longitude) {
				let iconName = '';
				if ((markersArray[place.latitude + '-' + place.longitude]) && (markersArray[place.latitude + '-' + place.longitude].length >= 2)) {
					let places = markersArray[place.latitude + '-' + place.longitude];
					let count = places.length;
					iconName = 'pin-' + count + '.png';
				}
				else {
					iconName = 'pin-' + place.category_icon + '.png';
				}
				let size = [40, 50];

				let position = {
					lat: parseFloat(place.latitude),
					lng: parseFloat(place.longitude)
				};

				if ((this.selectedPlace == place.uid) && (place.latitude) && (place.longitude)) {
					this.zoom = this.isMobile() ? 13 : 15;
					if ((markersArray[place.latitude + '-' + place.longitude]) && (markersArray[place.latitude + '-' + place.longitude].length >= 2)) {
						let places = markersArray[place.latitude + '-' + place.longitude];
						let count = places.length;
						iconName = 'pin-' + count + '-selected.png';
					}
					else {
						iconName = 'pin-' + place.category_icon + '-selected.png';
					}
					this.map.panTo(new google.maps.LatLng(position.lat, position.lng));
					size = [40, 50];
					this.currentZoom = this.map.getZoom();
					if (this.zoom !== this.map.getZoom()) {
						this.map.setZoom(this.zoom);
					}
					selected = true;
				}

				let icon = '/typo3conf/ext/apartlus/Resources/Public/Icons/maps/' + iconName;
				let marker = this.createMarker(icon, size, place.uid, selected);
				marker.setPosition(position);
				// marker.setLabel(place.name);
				marker.setMap(this.map);

				let placePosition = new google.maps.LatLng(place.latitude, place.longitude);
				boundWithAllPlaces.extend(placePosition);

				google.maps.event.addListener(marker, 'click', () => {
					if ((markersArray[place.latitude + '-' + place.longitude]) && (markersArray[place.latitude + '-' + place.longitude].length >= 2)) {
						$('.content-area').addClass('hidden');
						$('.map-info-block').removeClass('displayed');
						$('.map-info-block .loader-area').removeClass('hidden');
						$('.map-theme-container').removeClass('hidden');
						$('.suggestions-list').html('');
						$('.map-theme-selector').addClass('hidden');
						let placesList = this.placeList;
						setTimeout((e) => {
							this.selectedPlace = false;
							this.placeList = [];
							let places = markersArray[place.latitude + '-' + place.longitude];
							let address = '';
							let count = places.length;
							let icon = '';
							$.each(places, (aIndexPlace, aPlace) => {
								this.placeList[aIndexPlace] = aPlace;
								address = aPlace.address1 + ' ' + aPlace.address2;
								this.selectedPlace = aPlace.uid;
							});
							this.samePlaceList = places;
							this.attachPlaceList(true, address);
							this.placeList = placesList;
							this.attachMap();
							$('.map-info-block .loader-area').addClass('hidden');
						}, 1000);
						// alert('multiple');
					}
					else {
						this.samePlaceList = false;
						$('.map-theme-selector').removeClass('hidden');
						this.attachPlaceList();
						let id = marker.id;
						$('.place-search-item[data-uid=' + id + ']').click();
						this.attachPlaceDetails(id);
						// console.log(this.currentZoom + ' - ' + this.map.getZoom());
						if (this.currentZoom !== this.map.getZoom()) {
							this.map.setZoom(this.currentZoom);
						}
					}
				});

				this.markers.push(marker);
			}
		});


		if (typeof this.myPositionMarker !== 'undefined') {
			this.myPositionMarker.setVisible(false);
		}
		let bounds = false;
		if (aMyPosition.has('lat') && aMyPosition.has('lng') && this.useMyPosition) {
			this.zoom = this.isMobile() ? 12 : 15;
			let myPosition = new google.maps.LatLng(this.myPosition.lat, this.myPosition.lng);


			let icon = '/typo3conf/ext/apartlus/Resources/Public/Icons/maps/mapUserPosition@2x.png';
			this.myPositionMarker = this.createMarker(icon, [48, 48]);
			this.myPositionMarker.setPosition(this.myPosition);
			this.myPositionMarker.setMap(this.map);

			// let mapWrapperCenter = $('#map').width() / 2;
			// let listWrapper = $('.service-point-list-wrapper');
			// let listWrapperOffset = listWrapper.offset().left + listWrapper.width();
			// let listWrapperOffsetCenter = listWrapperOffset - mapWrapperCenter;
			// let newOffset = ((mapWrapperCenter / 2) - listWrapperOffsetCenter) / 2;
			// this.map.panTo(this.recenterMap(newOffset, 0, this.zoom));

			bounds = new google.maps.LatLngBounds();
			bounds.extend(myPosition);

			$.each(this.placeList, (index, place) => {
				if (index < 3) {
					let placePosition = new google.maps.LatLng(place.latitude, place.longitude);
					bounds.extend(placePosition);
				}
			});

			if (!this.selectedPlace) {
				this.map.fitBounds(bounds);
			}
		}

		this.clusteringMarkers();

		/*
         * Trigger a click if a place is in the hashtag of the page
         */
		if (this.firstLoad && this.urlPlace) {
			this.firstLoad = false;
			$('.place-search-item[data-uid=' + this.urlPlace + ']').click();
		}
	}

	recenterMap(offsetx, offsety) {
		if (typeof offsety === 'undefined') {
			offsety = 0;
		}

		let point1 = this.map.getProjection().fromLatLngToPoint(
			this.map.getCenter()
		);
		let point2 = new google.maps.Point(
			( (typeof(offsetx) === 'number' ? offsetx : 0) / Math.pow(2, this.zoom) ) || 0,
			( (typeof(offsety) === 'number' ? offsety : 0) / Math.pow(2, this.zoom) ) || 0
		);

		return this.map.getProjection().fromPointToLatLng(new google.maps.Point(
			point1.x - point2.x,
			point1.y + point2.y
		));
	}

	createMarker(iconPath, size, id, selected) {
		let marker = new google.maps.Marker({
			id: id,
			clickable: true,
			zIndex: selected ? 999 : 1
		});

		marker.setIcon(/** @type {google.maps.Icon} */({
			url: iconPath,
			size: new google.maps.Size(size[0] * 2, size[1] * 2),
			origin: new google.maps.Point(0, 0),
			scaledSize: new google.maps.Size(size[0], size[1]),
			anchor: new google.maps.Point(size[0] / 2, size[1]),
			animation: google.maps.Animation.DROP
		}));

		return marker;
	}

	clusteringMarkers() {
		if (this.markerCluster) {
			this.markerCluster.clearMarkers();
		}
		let clusterStyles = [{
			fontFamily: "'Open Sans', sans-serif",
			fontStyle: 'normal',
			fontWeight: 'bold',
			url: '/typo3conf/ext/apartlus/Resources/Public/Icons/maps/mapClusterBg@2x.png',
			height: 70,
			width: 70,
		}];

		let mcOptions = {};

		if (this.isMobile()) {
			mcOptions = {
				gridSize: 80,
				styles: clusterStyles,
				maxZoom: 12,
				enableRetinaIcons: true,
				clusterClass: 'place-cluster',
			};
		} else {
			mcOptions = {
				gridSize: 90,
				styles: clusterStyles,
				maxZoom: 13,
				enableRetinaIcons: true,
				clusterClass: 'place-cluster',
			};
		}

		this.markerCluster = new MarkerClusterer(this.map, this.markers, mcOptions);
	}

	attachPlaceFilters() {
		/*
         * On click on the filters buttons
         */
		let filter = $('#place-categories');
		filter.on('change', () => {
			let oldTags = this.tags;

			if (filter.val() === -1) {
				this.tags = '';
			} else {
				this.tags = filter.val();
			}

			if (this.tags !== oldTags) {
				this.attachPlaceListAndMap();
			}
		});
	}

	isMobile() {
		return $(window).width() <= 1024;
	}

	findGetParameter(parameterName) {
		let result = null,
			tmp = [];
		let items = location.search.substr(1).split("&");
		for (let index = 0; index < items.length; index++) {
			tmp = items[index].split("=");
			if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
		}
		return result;
	}

}